module.exports = __webpack_public_path__ + "static/digital0e5da3dd4c484400618e80d9c524e39a0.png";